/** Matches server-side `sanitizeFileName` before case-insensitive comparison. */
export function normalizePackagingDocumentFileName(fileName: string) {
  return fileName.replace(/[/\\]/g, '_').trim().toLowerCase()
}

export function findPackagingLibraryDocumentByFileName<
  T extends { fileName: string },
>(libraryDocuments: T[], fileName: string): T | undefined {
  const normalizedTarget = normalizePackagingDocumentFileName(fileName)
  return libraryDocuments.find(
    (row) =>
      normalizePackagingDocumentFileName(row.fileName) === normalizedTarget
  )
}

export function isPackagingLibraryDocumentAttachedToItem(input: {
  libraryDocumentId: string
  documentType: string
  itemDocuments: Array<{ id: string; documentType: string }>
}) {
  return input.itemDocuments.some(
    (document) =>
      document.id === input.libraryDocumentId &&
      document.documentType === input.documentType
  )
}
